// DO NOT EDIT -- generated from fs/services/dex/admin.proto

import { CreateSearchExportRequest } from './dataexport.proto';
import * as protobuf from '../../../google/protobuf';

export namespace Admin {

  export const GetSearchExportStatsEndpoint = "/grpc/dexapi.Admin/GetSearchExportStats";
  /** GetSearchExportStats returns doc counts and time slices for how work would be broken up for the provided search export. */
  export function GetSearchExportStats(sender: (req: CreateSearchExportRequest, endpoint: string) => Promise<GetSearchExportStatsResponse>, req: CreateSearchExportRequest): { promise: () => Promise<GetSearchExportStatsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetSearchExportStatsEndpoint),
      endpoint: GetSearchExportStatsEndpoint
    };
  }

  export const SetSearchExportScalingConfigEndpoint = "/grpc/dexapi.Admin/SetSearchExportScalingConfig";
  /** SetSearchExportScalingConfig sets or clears the scaling config globally or for a specific org. */
  export function SetSearchExportScalingConfig(sender: (req: SetSearchExportScalingConfigRequest, endpoint: string) => Promise<SetSearchExportScalingConfigResponse>, req: SetSearchExportScalingConfigRequest): { promise: () => Promise<SetSearchExportScalingConfigResponse>, endpoint: string } {
    return {
      promise: () => sender(req, SetSearchExportScalingConfigEndpoint),
      endpoint: SetSearchExportScalingConfigEndpoint
    };
  }

  export const GetZKDataEndpoint = "/grpc/dexapi.Admin/GetZKData";
  /**
   * GetZKData returns the zookeeper data at the provided path.
   * This is provided so that ssh access to zookeeper is unnecessary for debugging.
   */
  export function GetZKData(sender: (req: GetZKDataRequest, endpoint: string) => Promise<GetZKDataResponse>, req: GetZKDataRequest): { promise: () => Promise<GetZKDataResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetZKDataEndpoint),
      endpoint: GetZKDataEndpoint
    };
  }
}

export namespace ExportMetrics {

  export const GetActiveOrgsEndpoint = "/grpc/dexapi.ExportMetrics/GetActiveOrgs";
  /** Per org metrics endpoints */
  export function GetActiveOrgs(sender: (req: {}, endpoint: string) => Promise<GetActiveOrgsResponse>, req: {}): { promise: () => Promise<GetActiveOrgsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetActiveOrgsEndpoint),
      endpoint: GetActiveOrgsEndpoint
    };
  }

  export const GetOutstandingWorkEndpoint = "/grpc/dexapi.ExportMetrics/GetOutstandingWork";
  export function GetOutstandingWork(sender: (req: {}, endpoint: string) => Promise<GetOutstandingWorkResponse>, req: {}): { promise: () => Promise<GetOutstandingWorkResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetOutstandingWorkEndpoint),
      endpoint: GetOutstandingWorkEndpoint
    };
  }

  export const GetActiveWorkClaimsEndpoint = "/grpc/dexapi.ExportMetrics/GetActiveWorkClaims";
  export function GetActiveWorkClaims(sender: (req: {}, endpoint: string) => Promise<GetActiveWorkClaimsResponse>, req: {}): { promise: () => Promise<GetActiveWorkClaimsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetActiveWorkClaimsEndpoint),
      endpoint: GetActiveWorkClaimsEndpoint
    };
  }

  export const GetMaxAgeExportEndpoint = "/grpc/dexapi.ExportMetrics/GetMaxAgeExport";
  export function GetMaxAgeExport(sender: (req: {}, endpoint: string) => Promise<GetMaxAgeExportResponse>, req: {}): { promise: () => Promise<GetMaxAgeExportResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetMaxAgeExportEndpoint),
      endpoint: GetMaxAgeExportEndpoint
    };
  }

  export const GetMaxAgeSinceLastFinishedEndpoint = "/grpc/dexapi.ExportMetrics/GetMaxAgeSinceLastFinished";
  export function GetMaxAgeSinceLastFinished(sender: (req: {}, endpoint: string) => Promise<GetMaxAgeSinceLastFinishedResponse>, req: {}): { promise: () => Promise<GetMaxAgeSinceLastFinishedResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetMaxAgeSinceLastFinishedEndpoint),
      endpoint: GetMaxAgeSinceLastFinishedEndpoint
    };
  }

  export const GetOutstandingExpirationsEndpoint = "/grpc/dexapi.ExportMetrics/GetOutstandingExpirations";
  export function GetOutstandingExpirations(sender: (req: {}, endpoint: string) => Promise<GetOutstandingExpirationsResponse>, req: {}): { promise: () => Promise<GetOutstandingExpirationsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetOutstandingExpirationsEndpoint),
      endpoint: GetOutstandingExpirationsEndpoint
    };
  }
}

export interface GetActiveOrgsResponse {
  orgs: string[];
}

export interface GetOutstandingWorkResponse {
  orgs: { [key: string]: protobuf.int64 };
}

export interface GetActiveWorkClaimsResponse {
  orgs: { [key: string]: protobuf.int64 };
}

export interface GetMaxAgeExportResponse {
  orgs: { [key: string]: protobuf.duration };
}

export interface GetMaxAgeSinceLastFinishedResponse {
  orgs: { [key: string]: protobuf.duration };
}

export interface GetOutstandingExpirationsResponse {
  expirations: { [key: string]: unknown };
}

export interface GetSearchExportStatsResponse {
  /** The overall statistics of the export */
  total: GetSearchExportStatsResponse.TimeRangeStats | null;
  /** The statistics for each work slice. */
  shards: GetSearchExportStatsResponse.TimeRangeStats[];
}

export namespace GetSearchExportStatsResponse {
  export interface TimeRangeStats {
    /** The doc count for the time range */
    count: protobuf.int64;
    /** The first doc in the search by "EventStart" for event exports and "UserCreated" for individual exports. */
    start: protobuf.timestamp | null;
    /** The last doc in search by "EventStart" for event exports and "UserCreated" for individual exports. */
    end: protobuf.timestamp | null;
  }
}

export interface SearchExportScalingConfig {
  /** The maximum number of workers allowed to be running for a single org. */
  maxAllowedWorkers: number;
}

export interface SetSearchExportScalingConfigRequest {
  /**
   * Optional.
   * The scaling config to store.
   * If empty, the scaling config will be cleared.
   */
  scalingConfig: SearchExportScalingConfig | null;
  set: SetSearchExportScalingConfigRequest.Set;
  /**
   * Required if SetFor = ORG.
   * The org id the scaling config applies to.
   */
  orgId: string;
}

export namespace SetSearchExportScalingConfigRequest {
  export enum Set {
    SET_INVALID = 0,
    /**
     * Set the global fallback config.
     * The corresponding config will be used when an org config is not set.
     * Values are limited by the global max (if set).
     */
    SET_GLOBAL_FALLBACK = 1,
    /**
     * Set the global max config.
     * The corresponding config will be used as a max (for applicable values) for all orgs when set.
     * Orgs will still respect their org config, the global fallback, or the default when less than the global max.
     */
    SET_GLOBAL_MAX = 2,
    /**
     * Set an org specific config.
     * The corresponding config will be used for the org.
     * Values are limited by the global max (if set).
     */
    SET_ORG = 3
  }
}

export interface SetSearchExportScalingConfigResponse {
  /**
   * The ids of the orgs that were affected by the scaling (i.e. their scaling config changed).
   * Each of these orgs will have had the work manager scheduled to reallocate work.
   */
  affectedOrgIds: string[];
}

export interface GetZKDataRequest {
  path: string;
}

export interface GetZKDataResponse {
  data: object | null;
  children: string[];
}
